module.exports = __webpack_public_path__ + "img/barra_feder.a95de55a.png";